import React from 'react';
import {
  AppBar,
  Box,
  Dialog,
  DialogContent,
  DialogProps,
  Divider,
  IconButton,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { Rating } from '@material-ui/lab';
import { Close } from '@material-ui/icons';
import moment from 'moment';
import RatingStarIcon from 'assets/icons/svg/RatingStarIcon';
import { ECriteriaRatingType, ICriteriaRating } from '../../../interfaces';
import { getMoMark } from '../../../helpers';

interface IProps extends Omit<DialogProps, 'onClose'> {
  dateAt: string;
  realEstateName: string;
  relationRating?: number;
  criteriaRatings: ICriteriaRating[];
  onClose(): void;
}

const PartnerRatingMoDetailDialog: React.FC<IProps> = ({
  dateAt,
  realEstateName,
  relationRating,
  criteriaRatings,
  onClose,
  ...props
}) => {
  return (
    <Dialog {...props} onClose={onClose} maxWidth="sm" fullWidth scroll="paper">
      <AppBar style={{ position: 'relative' }}>
        <Box component={Toolbar} sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box>
            <Typography component="h3" variant="h6">
              <b>Детализация оценки МО за {moment(dateAt, 'YYYY-MM').format('MMMM YYYY')}</b>
            </Typography>
            <Typography component="p" variant="body2">
              {realEstateName}
            </Typography>
          </Box>

          <IconButton aria-label="Закрыть" color="inherit" onClick={onClose}>
            <Close color="inherit" />
          </IconButton>
        </Box>
      </AppBar>

      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 2 }}>
          <Typography component="span" variant="h6">
            Итоговая оценка МО
          </Typography>
          <Typography component="span" variant="h5" color="primary">
            <b>{getMoMark(relationRating)}</b>
          </Typography>
        </Box>

        <Divider />

        {criteriaRatings.map((criteriaRating) => (
          <Box
            key={criteriaRating.criteriaRatingId}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gridGap: 16, py: 1.5 }}
          >
            <Typography component="span" variant="body2" style={{ flex: 1 }}>
              {criteriaRating.criteriaRatingName}
            </Typography>

            {criteriaRating.type === ECriteriaRatingType.Mark ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gridGap: 8 }}>
                <Rating icon={<RatingStarIcon />} value={Number(criteriaRating.value)} max={5} readOnly />
                <Typography component="span" variant="body2" noWrap>
                  {criteriaRating.value}/5
                </Typography>
              </Box>
            ) : (
              <Typography component="span" variant="body2" noWrap>
                <b>{criteriaRating.value}</b>
              </Typography>
            )}
          </Box>
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default PartnerRatingMoDetailDialog;
